export default "__VITE_ASSET__e8b0ac20__"